<template>
  <div class="backtest-container">
    <div class="backtest-sidebar">
      <h5 class="text-center mb-20 font-30 bold-font">Algorithm Test</h5>

      <!-- Create Test Form -->
      <BackTestForm @test-created="handleTestCreated" />

      <!-- Test History -->
      <BackTestHistory
        :tests="tests"
        :selectedTestId="selectedTestId"
        :loading="loading"
        :totalCount="totalCount"
        @select-test="handleSelectTest"
        @load-more="handleLoadMore"
      />
    </div>

    <div class="backtest-main">
      <BackTestDetail
        v-if="selectedTestId"
        :key="selectedTestId"
        :testId="selectedTestId"
        @refresh="loadTests"
      />
      <div v-else class="empty-state">
        <p>Select a test from the history to view details</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackTestForm from '@/components/backtest/BackTestForm.vue'
import BackTestHistory from '@/components/backtest/BackTestHistory.vue'
import BackTestDetail from '@/components/backtest/BackTestDetail.vue'
import BackTestApiService from '@/services/BackTestApiService'
import { jobTypes } from '@/const'

export default {
  name: 'BackTest',
  components: {
    BackTestForm,
    BackTestHistory,
    BackTestDetail
  },
  data() {
    return {
      tests: [],
      selectedTestId: null,
      loading: false,
      refreshInterval: null,
      totalCount: 0,
      currentPage: 1,
      pageSize: 100
    }
  },
  mounted() {
    this.loadTests()
    // Auto-refresh test list every 30 seconds
    this.refreshInterval = setInterval(() => {
      this.loadTests()
    }, 30000)
  },
  beforeDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval)
    }
  },
  methods: {
    async loadTests(page = 1) {
      this.loading = true
      try {
        const response = await BackTestApiService.getBackTestList({
          page: page,
          pageSize: this.pageSize,
          jobType: [
            jobTypes.backTestingVolumeEstimation,
            jobTypes.backTestingRedAlert,
            jobTypes.backTestingNewPad
          ].join(',')
        })

        const data = response.data
        if (page === 1) {
          this.tests = data.Items || []
        } else {
          this.tests = [...this.tests, ...(data.Items || [])]
        }

        this.totalCount = data.TotalCount || 0
        this.currentPage = data.CurrentPage || 1

        // Auto-select the most recent test if none selected
        if (!this.selectedTestId && this.tests.length > 0) {
          this.selectedTestId = this.tests[0].Id
        }
      } finally {
        this.loading = false
      }
    },
    handleTestCreated(testId) {
      this.loadTests()
      this.selectedTestId = testId
    },
    handleSelectTest(testId) {
      this.selectedTestId = testId
    },
    handleLoadMore() {
      this.loadTests(this.currentPage + 1)
    }
  }
}
</script>

<style scoped lang="scss">
.backtest-sidebar {
  width: 360px;
  border-right: 1px solid #ddd;
  padding: 20px;
  overflow: hidden;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.backtest-main {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #fff;
}

::v-deep .backtest-form {
  flex-shrink: 0;
}

::v-deep .backtest-history {
  flex: 1;
  overflow-y: auto;
  margin-right: -20px;
  margin-bottom: -20px;
  padding-right: 20px;
  padding-bottom: 20px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
  font-size: 16px;
}
</style>
